import { Schema } from "@cak-legacy/generation-core";
import { ReadContainer } from "@cak-legacy/generation-overview";
import * as React from "react";
import { FormBaseComponentState } from "../Interfaces/form-base-component-state";
import { translate } from "../Locales/translator";

export interface IBevestigPaginaProps<T, X> {
  introText?: JSX.Element;
  introConfirmPageText?: JSX.Element;
  getSchema: () => Schema;
  values: T;
  additionalMessage?: string | JSX.Element;
  submitConfirmationText?: string;
  formState: FormBaseComponentState;
  setFormState: (value: FormBaseComponentState) => void;
  handleSubmit: (values: T) => Promise<X>;
  setErrorMessage: (value: string) => void;
  hasConfirmed: boolean;
  setConfirmed: (value: boolean) => void;
  gotoEnterFormState: (event: any) => void;
  onCancelForm: (event: any) => void;
  setValues: (values: T) => void;
  mapResponse: (values: X) => X;
  primaryButtonClassName?: string;
  secondaryButtonClassName?: string;
  primaryButtonText?: string;
  skipEditPageAndShowConfirmationOnly?: boolean;
  showCancelButtonIfEditPageIsSkipped?: boolean;
}

export const BevestigPagina = <T extends unknown, X extends unknown>(props: IBevestigPaginaProps<T, X>) => {
  return (
    <>
      {props.introConfirmPageText || props.introText}
      <ReadContainer
        schema={props.getSchema()}
        values={props.values}
        uiDefaults={{ flexDirectionFormGroupControl: "column" }}
      ></ReadContainer>
      {props.additionalMessage && (
        <div className="klant-ondersteuning-form__buttons-container klant-ondersteuning-form__melding-noteer-nummer">
          {typeof props.additionalMessage === "string" ? (
            <p>{props.additionalMessage}</p>
          ) : (
            <>{props.additionalMessage}</>
          )}
        </div>
      )}
      <div className="klant-ondersteuning-form__buttons-container mb-0 py-0 justify-content-start">
        {props.submitConfirmationText && (
          <label>
            <input
              id="chkConfirmation"
              type="checkbox"
              style={{ marginRight: 8 }}
              checked={props.hasConfirmed}
              onChange={(event) => props.setConfirmed(event.target.checked)}
            />
            {props.submitConfirmationText}
          </label>
        )}
      </div>
      <div className="klant-ondersteuning-form__buttons-container mt-0">
        {!props.skipEditPageAndShowConfirmationOnly && (
          <button
            className={`${props.secondaryButtonClassName ?? "btn btn-secondary"}`}
            id="vorigeButton"
            disabled={props.formState === FormBaseComponentState.SendingForm}
            onClick={(event) => props.gotoEnterFormState(event)}
          >
            {translate("Vorige")}
          </button>
        )}
        {props.skipEditPageAndShowConfirmationOnly && props.showCancelButtonIfEditPageIsSkipped && (
          <button
            className={`${props.secondaryButtonClassName ?? "btn btn-secondary"}`}
            id="vorigeButton"
            disabled={props.formState === FormBaseComponentState.SendingForm}
            onClick={(event) => props.onCancelForm(event)}
          >
            {translate("Annuleren")}
          </button>
        )}
        <button
          className={`${props.primaryButtonClassName ?? "btn btn-primary"}`}
          id="verzendenButton"
          disabled={
            props.formState === FormBaseComponentState.SendingForm ||
            (!!props.submitConfirmationText && !props.hasConfirmed)
          }
          onClick={async (e) => {
            e.preventDefault();

            props.setFormState(FormBaseComponentState.SendingForm);

            props
              .handleSubmit(props.values)
              .then((response: X) => {
                props.setValues({
                  ...(props.values as any),
                  ...(props.mapResponse(response) as any)
                });
                props.setFormState(FormBaseComponentState.FormWasSend);
              })
              .catch((catchederrorMessage: string) => {
                props.setErrorMessage(catchederrorMessage);
                props.setFormState(FormBaseComponentState.FormSendFailed);
              });
          }}
        >
          {props.formState === FormBaseComponentState.SendingForm && (
            <span className="icon icon-spinner rotate-icon"></span>
          )}
          <span>{props.primaryButtonText ?? translate("Verzenden")}</span>
          <span className="glyphicon glyphicon-menu-right"></span>
        </button>
      </div>
    </>
  );
};
